import { CommonModule } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule } from '@angular/core';

import { SeasonResourceService } from './season-resource.service';
import { SeasonResolver } from './season.resolver';
import { ApiResourceModule } from '../api-resource/api-resource.module';

@NgModule({
  declarations: [],
  exports: [],
  imports: [CommonModule, ApiResourceModule],
  providers: [
    SeasonResourceService,
    SeasonResolver,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class SeasonResourceModule {}
